
import React from "react";
import { ALL, isFilterActive, sessionLabelFor } from "./eventFilterUtils";

const EventFilterBar = ({
  searchValue, // input ka local text
  onSearchChange,
  onSearch, // Find / Enter
  totalCount = 0,
  matchedCount = 0,
  filters, // { studio, session, entry }
  onRemoveFilter, // (key) => void   key: "studio" | "session" | "entry"
  onClearAll,
}) => {
  const active = isFilterActive(filters);
  const noMatches = active && matchedCount === 0;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSearch();
    }
  };

  return (
    <div className="ef-bar">
      <div className="ef-search">
        {/* <span className="ef-search__icon" aria-hidden="true">
          &#128269;
        </span> */}
        <input
          type="text"
          className="ef-search__input"
          placeholder="Search entry # (e.g. 154 or 2.1)"
          value={searchValue}
          onChange={(e) => {
            const v = e.target.value;
            // khali, ya digits + max ek decimal point (2, 2., 2.1)
            if (v === "" || /^\d*\.?\d*$/.test(v)) onSearchChange(v);
          }}
          onKeyDown={handleKeyDown}
          aria-label="Search entry number"
        />
        <button type="button" className="ef-search__btn" onClick={onSearch}>
          Find
        </button>
      </div>

      <div className="ef-bar__right">
        <span className={`ef-count ${noMatches ? "is-empty" : ""}`}>
          {active
            ? `Showing ${matchedCount} of ${totalCount} routines`
            : `${totalCount} routines`}
        </span>

        {filters?.entry && filters.entry.trim() !== "" && (
          <span className="ef-chip">
            Entry #{filters.entry}
            <button
              type="button"
              className="ef-chip__x"
              onClick={() => onRemoveFilter("entry")}
              aria-label={`Remove entry search ${filters.entry}`}
            >
              &times;
            </button>
          </span>
        )}

        {filters?.studio && filters.studio !== ALL && (
          <span className="ef-chip">
            Studio: {filters.studio}
            <button
              type="button"
              className="ef-chip__x"
              onClick={() => onRemoveFilter("studio")}
              aria-label={`Remove studio filter ${filters.studio}`}
            >
              &times;
            </button>
          </span>
        )}

        {filters?.session && filters.session !== ALL && (
          <span className="ef-chip">
            {sessionLabelFor(filters.session)}
            <button
              type="button"
              className="ef-chip__x"
              onClick={() => onRemoveFilter("session")}
              aria-label={`Remove ${sessionLabelFor(filters.session)} filter`}
            >
              &times;
            </button>
          </span>
        )}

        {active && (
          <button type="button" className="ef-clearall" onClick={onClearAll}>
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
};

export default EventFilterBar;